var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.263306,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#F04444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7098 12.6958C11.7099 12.696 11.7098 12.6962 11.7099 12.6964L11.8325 16.4066C11.8417 16.6846 12.0501 16.9032 12.2981 16.8949C12.546 16.8866 12.7396 16.6545 12.7304 16.3765L12.648 13.8855L19.6043 21.2153C19.7858 21.4064 20.07 21.3977 20.2393 21.1957C20.4086 20.9937 20.3987 20.675 20.2173 20.4838L13.261 13.1541L15.4833 13.0914C15.7313 13.0844 15.9258 12.8534 15.9178 12.5754C15.9098 12.2973 15.7023 12.0777 15.4543 12.0847L12.1443 12.178C12.1441 12.178 12.1439 12.178 12.1437 12.178C11.8953 12.1854 11.701 12.4181 11.7098 12.6958Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.ed87bc9b.svg";
export { ForwardRef as ReactComponent };